import _ from "underscore";

import DotsOptionsMenu from "components/Menus/DotsOptionsMenu";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import { getTextColor } from "utils/DashboardUtils";
import { AppConfirm } from "utils/PopupUtil";

const getFontSize = (size) => {
  switch (size) {
    case "h1":
      return 40;
    case "h2":
      return 30;
    case "h3":
      return 20;
    default:
      return 30;
  }
};

const Options = ({ startEditing, onDelete }) => (
  <PopoverDropdownMenu>
    <DropdownOptionWithIcon
      icon="mdi mdi-cog"
      onClick={startEditing}
      name="Settings"
    />
    <DropdownOptionWithIcon
      name="Delete"
      onClick={onDelete} // Open Drawer
      icon="mdi mdi-delete"
    />
  </PopoverDropdownMenu>
);

const HeaderWidget = ({
  section,
  setSettings,
  editMode,
  deleteWidget,
  record,
}) => {
  const textColor = getTextColor(section?.Color);
  const fontSize = getFontSize(section?.Size);

  const handleDelete = () => {
    AppConfirm({
      title: `Delete "${section?.Name}" Widget?`,
      text: "Are you sure you want to delete this widget. This cannot be undone.",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteWidget(section.id);
      }
    });
  };

  const getMention = (originalString) => {
    if (!record || !originalString) return originalString;

    try {
      _.templateSettings = {
        interpolate: /\{\{(.+?)\}\}/g,
      };
      const compiledTemplate = _.template(originalString);
      return compiledTemplate(record);
    } catch {
      return originalString.replace(/{{\s*[^{}]+\s*}}/g, "");
    }
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-center`}
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: section?.Color || "unset",
        overflow: "hidden",
      }}
    >
      <div style={{ width: "100%", textAlign: section?.Alignment || "center" }}>
        <div
          style={{ color: textColor, fontSize: fontSize }}
          className="px-4 font-weight-600"
        >
          {getMention(section.Name)}
        </div>
        <div className="font-weight-500 px-4" style={{ color: textColor }}>
          {getMention(section.Description)}
        </div>
        {editMode && (
          <div
            className="d-inline-block"
            style={{ position: "absolute", top: 5, right: 5 }}
          >
            <DotsOptionsMenu
              dotsSize="22"
              placement="autoVerticalEnd"
              iconColor={textColor}
              options={
                <Options
                  startEditing={() => setSettings(section)}
                  onDelete={handleDelete}
                />
              }
            />
          </div>
        )}
      </div>
      {editMode && (
        <i
          style={{
            position: "absolute",
            left: 1,
            top: 1,
            color: textColor,
            fontSize: 24,
          }}
          className="mdi mdi-drag rgl-drag-handle cursor-pointer"
        />
      )}
    </div>
  );
};

export default HeaderWidget;
